import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Form, Spinner } from "react-bootstrap";
import axios from 'helpers/api';
import moment from "moment";

const findLabel = (options = [], value) => {
  if (value === null || value === undefined || value === "" || Number(value) === 0) {
    return "N/A";
  }
  return options.find(o => Number(o.value) === Number(value))?.key || "N/A";
};

const OldPrescriptionModal = ({
  show,
  onClose,
  prescriptionId,
  masterData
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [facilityName, setFacilityName] = useState("");
  const [splitMedsData, setSplitMedsData] = useState([]);


  const facilities = JSON.parse(localStorage.getItem("facilitiesData")) || [];

  useEffect(() => {
    if (show && prescriptionId) {
      fetchOldPrescription();
    }
  }, [show, prescriptionId]);

  const fetchOldPrescription = async () => {
    try {
      setLoading(true);
      const tokenStr = localStorage.getItem("accessToken");

      const payload = {
        prescription: {
          id: prescriptionId
        }
      };

      const res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/prescriptions/fetch-multiple`,
        payload,
        { headers: { Authorization: `Bearer ${tokenStr}` } }
      );

      const mainData = res.data.output.data.prescription[0];
      setData(mainData);

      // 👇 MAP SPLITMEDS
      if (mainData.is_splitmeds && mainData.splitmeds?.length) {
        const mappedSplitMeds = mainData.splitmeds.map((item) => {
          const freqObj = masterData.freqOptions?.find(
            f => Number(f.value) === Number(item.frequency_id)
          );

          const amountObj = masterData.amtOptions?.find(
            a => Number(a.value) === Number(item.amount_id)
          );

          return {
            sig: item.sig,
            dose: item.dose,
            amount: amountObj?.key || "N/A",
            frequency: freqObj?.key || "N/A",
            hours: [
              item.time_1,
              item.time_2,
              item.time_3,
              item.time_4
            ].filter(Boolean)
          };
        });

        setSplitMedsData(mappedSplitMeds);
      }


      const facility = facilities.find(f => f.value == mainData.facility_id);
      setFacilityName(facility?.key || "");
    } catch (err) {
      console.error("Error fetching old prescription", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show}
      onHide={onClose}
      size="xl"
      backdrop="static"
      dialogClassName="old-prescription-modal"
      centered>
      <Modal.Header closeButton className="border-bottom">
        <Modal.Title className="fw-bold text-primary">
          Old Prescription Details
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="old-prescription-body">
        {loading || !data ? (
          <div className="d-flex justify-content-center my-5">
            <Spinner animation="border" />
          </div>
        ) : (
          <div className="old-prescription-scroll">
            <div className="old-prescription-section">
              <h6>Basic Information</h6>
              <Row className="g-3">
                <Col md={4}>
                  <Form.Label>Facility</Form.Label>
                  <Form.Control value={facilityName} disabled className="readonly-input" />
                </Col>
                <Col md={4}>
                  <Form.Label>Individual</Form.Label>
                  <Form.Control
                    value={`${data.patient_lastname}, ${data.patient_firstname}`}
                    disabled
                    className="readonly-input"
                  />
                </Col>
                <Col md={4}>
                  <Form.Label>Rx Number</Form.Label>
                  <Form.Control
                    value={data.pharmacy_order_id || ""}
                    disabled
                    className="readonly-input"
                  />
                </Col>
                <Col md={6}>
                  <Form.Label>HCP</Form.Label>
                  <Form.Control
                    value={`${data.doctor_lastname}, ${data.doctor_firstname}`}
                    disabled
                    className="readonly-input"
                  />
                </Col>
              </Row>
            </div>

            <div className="old-prescription-section">
              <h6>Drug Information</h6>
              <Row className="g-3">
                <Col md={4}>
                  <Form.Label>Drug</Form.Label>
                  <Form.Control value={data.drug} disabled className="readonly-input" />
                </Col>
                <Col md={4}>
                  <Form.Label>Drug Form</Form.Label>
                  <Form.Control value={data.drug_form} disabled className="readonly-input" />
                </Col>
                <Col md={4}>
                  <Form.Label>NDC</Form.Label>
                  <Form.Control value={data.drug_ndc} disabled className="readonly-input" />
                </Col>
                <Col md={6}>
                  <Form.Label>Brand</Form.Label>
                  <Form.Control value={data.brand_drug} disabled className="readonly-input" />
                </Col>
                <Col md={6}>
                  <Form.Label>Generic</Form.Label>
                  <Form.Control value={data.generic} disabled className="readonly-input" />
                </Col>
              </Row>
            </div>

            <div className="old-prescription-section">
              <h6>Dose Information</h6>
              <Row className="g-3">
                <Col md={4}>
                  <Form.Label>Amount</Form.Label>
                  <Form.Control
                    value={findLabel(masterData.amtOptions, data.amount_id)}
                    disabled
                    className="readonly-input"
                  />
                </Col>
                <Col md={4}>
                  <Form.Label>Drug Unit</Form.Label>
                  <Form.Control
                    value={findLabel(masterData.drugUnitOptions, data.drugunit_id)}
                    disabled
                    className="readonly-input"
                  />
                </Col>
                <Col md={4}>
                  <Form.Label>Dose</Form.Label>
                  <Form.Control value={data.dose} disabled className="readonly-input" />
                </Col>
              </Row>
            </div>

            <div className="old-prescription-section">
              <h6>Administration</h6>
              <Row className="g-3">
                <Col md={6}>
                  <Form.Label>Frequency</Form.Label>
                  <Form.Control
                    value={findLabel(masterData.freqOptions, data.frequency_id)}
                    disabled
                    className="readonly-input"
                  />
                </Col>
                <Col md={6}>
                  <Form.Label>Route</Form.Label>
                  <Form.Control
                    value={findLabel(masterData.routeOptions, data.route_id)}
                    disabled
                    className="readonly-input"
                  />
                </Col>

                <Col md={12}>
                  <Form.Label>{data.is_splitmeds ? "Split Medications" : "Timings"}</Form.Label>

                  {/* ===== NORMAL MEDS ===== */}
                  {!data.is_splitmeds && (
                    <div className="d-flex gap-2 flex-wrap mt-1">
                      {[data.time_1, data.time_2, data.time_3, data.time_4,
                      data.time_5, data.time_6, data.time_7, data.time_8]
                        .filter(t => t && t !== "0")
                        .map((t, i) => (
                          <span key={i} className="timing-pill">
                            {masterData.time1options?.find(opt => opt.value === t)?.key || t}
                          </span>
                        ))}
                    </div>
                  )}

                  {/* ===== SPLIT MEDS (READ ONLY GRID) ===== */}
                  {data.is_splitmeds && (
                    <div className="splitmeds-compact">
                      {splitMedsData.map((row, idx) => (
                        <div className="splitmeds-compact-row">
                          {/* Direction */}
                          <div className="splitmeds-title">
                            <span className="section-label">Direction</span>
                            <span className="section-value">{row.sig}</span>
                          </div>

                          {/* Meta row */}
                          <div className="splitmeds-meta">
                            <div>
                              <span className="meta-label">Amount</span>
                              <span className="meta-value">{row.amount}</span>
                            </div>

                            <div>
                              <span className="meta-label">Dose</span>
                              <span className="meta-value">{row.dose}</span>
                            </div>

                            <div>
                              <span className="meta-label">Frequency</span>
                              <span className="meta-value">{row.frequency}</span>
                            </div>

                            <div className="meta-hours">
                              <span className="meta-label hours-label">Hours</span>
                              <div className="d-flex gap-2 flex-wrap">
                                {row.hours.length ? (
                                  row.hours.map((h, i) => (
                                    <span key={i} className="hour-pill">
                                      {masterData.time1options?.find(opt => Number(opt.value) === Number(h))?.key || h}
                                    </span>
                                  ))
                                ) : (
                                  <span className="text-muted">N/A</span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                      ))}
                    </div>
                  )}


                </Col>

              </Row>
            </div>

            <div className="old-prescription-section">
              <h6>Dispensing Details</h6>
              <Row className="g-3">
                <Col md={6}>
                  <Form.Label>Pharmacy</Form.Label>
                  <Form.Control
                    value={findLabel(masterData.pharmacyOptions, data.pharmacy_store_id)}
                    disabled
                    className="readonly-input"
                  />
                </Col>

                <Col md={6}>
                  <Form.Label>Med Group</Form.Label>
                  <Form.Control
                    value={findLabel(masterData.medgroupOptions, data.medgroup_id)}
                    disabled
                    className="readonly-input"
                  />
                </Col>
              </Row>
            </div>

            <div className="old-prescription-section">
              <h6>Dates</h6>
              <Row className="g-3">
                <Col md={4}>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    value={data.client_startdate ? moment(data.client_startdate).format("MM/DD/YYYY") : ""}
                    disabled
                    className="readonly-input"
                  />
                </Col>
                <Col md={4}>
                  <Form.Label>Stop Date</Form.Label>
                  <Form.Control
                    value={data.client_stopdate ? moment(data.client_stopdate).format("MM/DD/YYYY") : ""}
                    disabled
                    className="readonly-input"
                  />
                </Col>
                <Col md={4}>
                  <Form.Label>Expiry Date</Form.Label>
                  <Form.Control
                    value={data.pharmacy_expire_date ? moment(data.pharmacy_expire_date).format("MM/DD/YYYY") : ""}
                    disabled
                    className="readonly-input"
                  />
                </Col>
              </Row>
            </div>

            <div className="old-prescription-section">
              <h6>Timing Constraints</h6>
              <Row className="g-3">
                <Col md={4}>
                  <Form.Label>Early / Late</Form.Label>
                  <Form.Control
                    value={data.early || "N/A"}
                    disabled
                    className="readonly-input"
                  />
                </Col>

                <Col md={4}>
                  <Form.Label>Time Between Other Meds</Form.Label>
                  <Form.Control
                    value={data.time_between_meds || "N/A"}
                    disabled
                    className="readonly-input"
                  />
                </Col>

                <Col md={4}>
                  <Form.Label>Not To Exceed</Form.Label>
                  <Form.Control
                    value={data.not_exceed || "N/A"}
                    disabled
                    className="readonly-input"
                  />
                </Col>
              </Row>
            </div>


            <div className="old-prescription-section">
              <h6>Clinical Details</h6>
              <Row className="g-3">
                <Col md={6}>
                  <Form.Label>Reason Prescribed</Form.Label>
                  <Form.Control value={data.reason_text} disabled className="readonly-input" />
                </Col>
                <Col md={6}>
                  <Form.Label>Special Instruction</Form.Label>
                  <Form.Control value={data.special_instruction_text} disabled className="readonly-input" />
                </Col>
                <Col md={6}>
                  <Form.Label>Call HCP If</Form.Label>
                  <Form.Control value={data.remarks} disabled className="readonly-input" />
                </Col>
                <Col md={6}>
                  <Form.Label>Medication Status</Form.Label>
                  <Form.Control value={data.medication_independent_status} disabled className="readonly-input" />
                </Col>
              </Row>
            </div>

            <div className="old-prescription-section">
              <h6>Flags</h6>
              <Row className="g-3">
                <Col md={3}><div className="flag-box">
                  <Form.Check label="PRN Medication" checked={data.med_type === "P"} disabled />
                </div></Col>
                <Col md={3}><div className="flag-box">
                  <Form.Check label="Medsheet" checked={data.mar_flag === 1} disabled />
                </div></Col>
                <Col md={3}><div className="flag-box">
                  <Form.Check label="Treatment" checked={data.tar_flag === 1} disabled />
                </div></Col>
                <Col md={3}><div className="flag-box">
                  <Form.Check label="Vital Signs" checked={data.has_vitalsigns === 1} disabled />
                </div></Col>
              </Row>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="border-top">
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OldPrescriptionModal;
